// IMPORTANT - does not seem to work with *.gts ???

import { themeClassNames } from 'webapp/models-custom/theme';

interface ClassType {
	prototype: object;
}

// what the getters below read on the decorated component
interface Themed {
	args: { theme?: string | null; size?: string | null };
	theme: string | null;
	size: string | null;
}

export default function themed() {
	return function <T extends ClassType>(Class: T): T {
		Object.defineProperty(Class.prototype, 'theme', {
			get(this: Themed) {
				return this.args.theme || null;
			},
		});

		Object.defineProperty(Class.prototype, 'themeClass', {
			get(this: Themed) {
				return themeClassNames(this.theme);
			},
		});

		Object.defineProperty(Class.prototype, 'size', {
			get(this: Themed) {
				return this.args.size || null;
			},
		});

		Object.defineProperty(Class.prototype, 'sizeClass', {
			get(this: Themed) {
				let sizeClass = '';
				if (this.size) {
					sizeClass = `size-${this.size}`;
				}
				return sizeClass;
			},
		});

		return Class;
	};
}
